const PrivilegeNames = Object.freeze({
    ABANDON_PAYMENTS: 'abandon_payments',
    ACCESS_ACCOUNTS: 'access_accounts',
    ACCESS_REDEEM: 'access_redeem',
    ACCESS_REPORT: 'access_report',
    ACCESS_SELL: 'access_sell',
    ACCESS_TODAY: 'access_today',
    ADD_CASH_TO_TILL: 'add_cash_to_till',
    ALLOW_UNREDEEM_MEMBERSHIPS: 'allow_unredeem_memberships',
    ALLOW_UNREDEEM_TICKETS: 'allow_unredeem_tickets',
    APPLY_DISCOUNTS: 'apply_discounts',
    APPLY_SUPERVISOR_DISCOUNTS: 'apply_supervisor_discounts',
    AUTH_ONLY_PAYMENTS: 'auth_only_payments',
    CHANGE_PRINT_SETTINGS: 'change_print_settings',
    CNP_PAYMENTS: 'cnp_payments',
    EDIT_ORDERS: 'edit_orders',
    ISSUE_REFUNDS: 'issue_refunds',
    MANUAL_PAYMENT_RECONCILIATION: 'manual_payment_reconciliation',
    OPEN_CASH_DRAWER: 'open_cash_drawer',
    PARTIAL_REFUND_OF_EXISTING_PAYMENT: 'partial_refund_of_existing_payment',
    REMOVE_CASH_FROM_TILL: 'remove_cash_from_till',
    TAKE_PARTIAL_PAYMENTS: 'take_partial_payments',
});

module.exports = PrivilegeNames;
